const indexItems = [
  { icon: 'ri-fire-line', label: '今日爆点', count: '32条', color: 'text-primary-500 bg-primary-50' },
  { icon: 'ri-star-line', label: '明星八卦', count: '156条', color: 'text-accent-500 bg-accent-50' },
  { icon: 'ri-movie-line', label: '影视综艺', count: '89条', color: 'text-primary-500 bg-primary-50' },
  { icon: 'ri-music-line', label: '音乐动态', count: '47条', color: 'text-accent-500 bg-accent-50' },
  { icon: 'ri-live-line', label: '直播吃瓜', count: '23条', color: 'text-primary-500 bg-primary-50' },
  { icon: 'ri-user-smile-line', label: '网红圈层', count: '64条', color: 'text-accent-500 bg-accent-50' },
  { icon: 'ri-newspaper-line', label: '内幕爆料', count: '38条', color: 'text-primary-500 bg-primary-50' },
  { icon: 'ri-trophy-line', label: '吃瓜大赛', count: '12期', color: 'text-accent-500 bg-accent-50' },
  { icon: 'ri-chat-smile-2-line', label: '瓜友社区', count: '活跃', color: 'text-primary-500 bg-primary-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            吃瓜索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            按主题快速浏览，精准定位你感兴趣的吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-9 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="flex flex-col items-center gap-2 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 hover:-translate-y-0.5 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-xl md:text-2xl group-hover:scale-110 transition-transform`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-[10px] md:text-xs text-foreground-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}